import request from "@/utils/request";

// 列表(主数据列表)
export function loadCallBackBaseSettingListDataApi(data) {
  return request({
    url: "web/callBackBaseSetting/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadCallBackBaseSettingExportDataApi(data) {
  return request({
    url: "web/callBackBaseSetting/exportData",
    method: "post",
    data
  });
}

// 新增修改
export function saveOrUpdateCallBackBaseSettingApi(data) {
  return request({
    url: "web/callBackBaseSetting/saveOrUpdate",
    method: "post",
    data
  });
}

// 初始化
export function initCallBackBaseSettingApi(data) {
  return request({
    url: "web/callBackBaseSetting/init",
    method: "post",
    data
  });
}